export default __webpack_public_path__ + "static/media/boiler-medium.3697fa00.png";